// Centralized log type color palette
// Used across histogram, Sankey, log type sidebars, and dashboards

export const LOG_TYPE_COLORS = {
  conn: '#7357D2',      // Purple (primary)
  dns: '#4A90D9',       // Blue
  http: '#50C878',      // Green
  ssl: '#F5A623',       // Orange
  x509: '#D94A4A',      // Red
  files: '#9B59B6',     // Violet
  smtp: '#1ABC9C',      // Teal
  ssh: '#E74C3C',       // Coral
  dhcp: '#3498DB',      // Light blue
  ntp: '#95A5A6',       // Gray
  rdp: '#E67E22',       // Dark orange
  ftp: '#27AE60',       // Dark green
  sip: '#8E44AD',       // Dark purple
  snmp: '#2980B9',      // Dark blue
  kerberos: '#C0392B',  // Dark red
  smb: '#16A085',       // Dark teal
  dce_rpc: '#D35400',   // Rust
  ntlm: '#7F8C8D',      // Dark gray
  pe: '#BDC3C7',        // Light gray
  weird: '#E91E63',     // Pink
  notice: '#FF5722',    // Deep orange
  software: '#607D8B',  // Blue gray
  known: '#795548',     // Brown
  _default: '#6B7280'   // Fallback gray
}

// Get color for a log type with fallback
export function getLogTypeColor(logType) {
  return LOG_TYPE_COLORS[logType] || LOG_TYPE_COLORS._default
}
